import en from "../../internationalization/languages/en";
import mk from "../../internationalization/languages/mk";
import { LanguageState, LanguageAction } from "../../types";

interface ExtendedLanguageState extends LanguageState {
  languages: string[];
  languageContents: Record<string, Record<string, string>>;
}

export const reducer = (state: ExtendedLanguageState, action: LanguageAction): ExtendedLanguageState => {
  switch (action.type) {
    case "setLanguage": {
      return { ...state, language: action.payload, translations: state.languageContents[action.payload] };
    }

    default:
      return state;
  }
};

export const initialState: ExtendedLanguageState = {
  language: "en" as 'en' | 'mk',
  languages: ["en", "mk"],
  languageContents: { en, mk },
  translations: en,
};

const fallbackLanguage = "mk";

function getFallbackLanguageContents(languageContents: Record<string, Record<string, string>>): Record<string, string> {
  return languageContents[fallbackLanguage];
}

function getFallbackLanguageTranslation(key: string, languageContents: Record<string, Record<string, string>>): string {
  return getFallbackLanguageContents(languageContents)[key];
}

function translate(key: string, state: ExtendedLanguageState): string {
  const { language: currentLanguage, languages, languageContents } = state;

  if (!languages.includes(currentLanguage))
    return `Language ${currentLanguage} not supported.`;

  let translation =
    languageContents[currentLanguage][key] ||
    getFallbackLanguageTranslation(key, languageContents);

  if (!translation) return `Key ${key} not defined in language files!`;

  return translation;
}

export function t(key: string, state: ExtendedLanguageState): string {
  return translate(key, state);
}
